// routes.js
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from "react-router-dom";
import VideoRecordScreen from "./screens/VideoRecordScreen";
import ViewVideoScreen from "./screens/ViewVideoScreen";
import Splash from "./screens/Splash";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<VideoRecordScreen />} />  {/* Default route */}
      <Route path="/splash" element={<Splash />} />  {/* Optional splash screen route */}
      <Route path="/view" element={<ViewVideoScreen />} />
      <Route path="*" element={<Navigate to="/" />} />
    </>
  )
);

export default router;
